<div id="teacher-calendar-index" class="container margin-top-1">
  <mat-card>
    <full-calendar [options]="calendarOptions" class="margin-top-1" #calendar>
    </full-calendar>
  </mat-card>
</div>
